// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.estimate[data-v-051160fc]{display:flex;align-items:center}.estimate-icon[data-v-051160fc]{color:#ffc633;width:2.4rem;height:2.4rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
